const WorkExperience = [
  {
    id: 1,
    company: "Desi Link Singapore",
    yearsActive: "June 2025 – Aug 2025",
    title: "Software Developer Intern",
    information: [
      "Developed Flask-based authentication microservices and deployed them using Docker for secure and modular access control.",
      "Integrated core backend APIs serving multiple client apps, improving system modularity and deployment speed by 25%.",
      "Collaborated directly with the founding engineering team to design scalable service architecture and database interactions.",
      "Improved CI/CD workflow and deployment consistency through containerized environments and API orchestration.",
    ],
  },
  {
    id: 2,
    company: "Parsewave.ai",
    yearsActive: "Freelance Project — May 2025",
    title: "Automation Developer (Terminal Bench Tasks)",
    information: [
      "Designed and implemented automation scripts to streamline internal data preprocessing workflows using Python.",
      "Developed a terminal-based task runner to automate the basic EDA (Exploratory Data Analysis) pipeline for structured datasets.",
      "Integrated data validation, feature summary generation, and performance logging modules to accelerate model experimentation.",
      "Reduced manual data exploration time by over 60% through modular and reusable automation logic.",
    ],
  },
  {
    id: 3,
    company: "YBI Foundation",
    yearsActive: "July 2024 – Aug 2024",
    title: "AI & ML Intern",
    information: [
      "Boosted model accuracy by 20% using advanced feature engineering and hyperparameter tuning.",
      "Developed data pipelines for cleaning, transformation, and feature extraction.",
      "Experimented with OpenAI APIs for prompt tuning on health-focused conversational datasets.",
      "Performed statistical evaluation for model reliability and explainability.",
    ],
  },
];

export default WorkExperience;
